import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { readConsent, saveConsent, applyStoredConsent, onOpenCookieSettings } from '../analytics/consent';
import { trackPhoneClicks } from '../analytics/tracking';

const texts = {
  fr: {
    message: "Nous utilisons des cookies de mesure d'audience et de publicité pour comprendre comment notre site est utilisé et mesurer l'efficacité de nos annonces. Ils ne sont déposés qu'avec votre accord.",
    more: 'En savoir plus',
    refuse: 'Tout refuser',
    accept: 'Tout accepter'
  },
  en: {
    message: 'We use audience measurement and advertising cookies to understand how our website is used and to measure how well our ads perform. They are only set with your consent.',
    more: 'Learn more',
    refuse: 'Reject all',
    accept: 'Accept all'
  }
};

const buttonStyle = {
  padding: '0.85rem 1.75rem',
  fontSize: '0.8rem',
  fontWeight: 500,
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  cursor: 'pointer',
  border: '1px solid #ffffff',
  minWidth: '170px'
};

// Bandeau de consentement : « Tout refuser » et « Tout accepter » ont le même poids visuel (exigence CNIL).
const CookieBanner = () => {
  const { language, localizePath } = useLanguage();
  const [visible, setVisible] = useState(false);
  const t = texts[language];

  useEffect(() => {
    // Le pré-rendu des pages ne doit pas figer le bandeau dans le HTML.
    if (window.__PRERENDER__) return undefined;
    applyStoredConsent();
    if (!readConsent()) setVisible(true);
    const stopPhoneTracking = trackPhoneClicks();
    const stopListening = onOpenCookieSettings(() => setVisible(true));
    return () => {
      stopPhoneTracking();
      stopListening();
    };
  }, []);

  if (!visible) return null;

  const choose = (accepted) => {
    saveConsent(accepted);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={language === 'fr' ? 'Gestion des cookies' : 'Cookie settings'}
      style={{
        position: 'fixed',
        left: '1rem',
        right: '1rem',
        bottom: '1rem',
        zIndex: 2000,
        maxWidth: '1100px',
        margin: '0 auto',
        background: 'rgba(10, 10, 10, 0.97)',
        border: '1px solid #262626',
        borderRadius: '8px',
        padding: '1.5rem',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '1.25rem',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.6)'
      }}
    >
      <p style={{ flex: '1 1 420px', margin: 0, fontSize: '0.9rem', color: '#d4d4d4', lineHeight: 1.6, fontWeight: 300 }}>
        {t.message}{' '}
        <a href={localizePath('/confidentialite')} style={{ color: '#ffffff' }}>{t.more}</a>
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        <button onClick={() => choose(false)} style={{ ...buttonStyle, background: 'transparent', color: '#ffffff' }}>
          {t.refuse}
        </button>
        <button onClick={() => choose(true)} style={{ ...buttonStyle, background: 'transparent', color: '#ffffff' }}>
          {t.accept}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
